// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"2d28fb65","84":"1051a9cc","113":"c88d6b99","177":"ada8f40d","277":"397aa736","401":"08bc7130","813":"762c2f8a"}[chunkId] + ".chunk.css";
};